const MultitentativeFillStatus = Object.freeze({
  Sent: 'sent',
  Queued: 'queued',
  Unavailable: 'unavailable',
})

const MultitentativeFillStatusLabels = Object.freeze({
  [MultitentativeFillStatus.Sent]: 'Sent',
  [MultitentativeFillStatus.Queued]: 'Not Sent',
  [MultitentativeFillStatus.Unavailable]: 'Unavailable',
})

export { MultitentativeFillStatus, MultitentativeFillStatusLabels }
